/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { HtmlPage } from '../../../widgets/landing-page-widget';
import { VerifyFailurePageService } from '../../../services';
import { VApplication } from '../../../application';
import { useTheme } from '../../../providers/theme';
import { useSMVerifyProductPage } from '../machines/pageContent';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import MiddleBlock from '../components/MiddleBlock';
import Image from 'react-bootstrap/Image';
import './custom.css';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.VerifyFailurePageService'
  ) as VerifyFailurePageService;
};

const _data = {
  title: 'Invalid QR Code',
  text: [''],
  titleStyle: { color: '#000000', fontFamily: 'Inter-VariableFont' },
  contentStyle: { color: '#000000', fontFamily: 'Inter-VariableFont' },
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const { width, height, bp } = useViewport();
  const staticPageContentConfig = srv?.getStaticPageContent();
  const [buttonItem, setButtonItem] = useState();

  const { verifyProductPageState } = useSMVerifyProductPage({});
  const content = staticPageContentConfig?.CONTENT;
  return (
    <>
      <div className='bubble' />
      <div className='bottomBubble' />
      <div className='bottomRectangle' />
      <div className='container' />
      <div className='headerLogoContainer'>
        {/* <Image
          src={'https://i.ibb.co/8dmDZGB/trag-text-logo.png'}
          width={'30%'}
        /> */}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: height - 54,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={
              'https://i.ibb.co/5B4Prxc/undraw-void-3ggu-Photo-Room-png-Photo-Room.png'
            }
            width={'40%'}
          />
          <MiddleBlock
            title={_data.title}
            content={_data.text}
            button={content.button}
            onClick={props?.onClick}
            section={content.section}
            id={content.id}
            scrollTo={content.scrollTo}
            key={`landing-page-middle`}
            link={content.link}
            color={props.color}
            secondaryColor={props.secondaryColor}
            onFocusColor={props?.onFocusColor}
            titleStyle={_data.titleStyle}
            contentStyle={_data.contentStyle}
            buttonPrimaryColor={content.buttonPrimaryColor}
            buttonSecondaryColor={content.buttonSecondaryColor}
            buttonFocusColor={content.buttonFocusColor}
          />
        </div>
      </div>
    </>
  );
};
